import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import DSLogoSmall from '../../assets/DataswiftLogoSmall';
import { formatDate } from '../../helpers/date-helper';
import { ApplicationInterface } from '../../interfaces/application';

type PropsType = {
  project: ApplicationInterface;
};

const useStyles = makeStyles((theme) => ({
  detailsHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    width: '470px',
    marginLeft: '68px',

    [theme.breakpoints.up('md')]: {
      marginLeft: '100px',
      width: '745px',
    },
  },
}));

const ProjectDetailsHeader: React.FC<PropsType> = ({ project }) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <div className={classes.detailsHeader}>
      <DSLogoSmall fill={theme.palette.text.primary} />

      <div className={classes.headerText}>
        <Typography variant="h1">{project.info.name}</Typography>
        <Typography variant="subtitle2">Application ID: {project.info.applicationId}</Typography>
        <Typography variant="subtitle2">
          Last update: {formatDate('dd/MM/yyyy, HH:mm:ss', project.lastUpdated)}
        </Typography>
      </div>
    </div>
  );
};

export default ProjectDetailsHeader;
